export default __webpack_public_path__ + "static/media/logo192.5ea2e2c1.png";